/* Слайдер отзывов */

function initReviewsSlider() {
  const reviewsSliderEl = document.querySelector('.reviews__slider');
  if (!reviewsSliderEl || typeof Swiper === 'undefined') return;

  new Swiper(reviewsSliderEl, {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 800,
    autoHeight: false,
    pagination: {
      el: reviewsSliderEl.querySelector('.swiper-pagination'),
      type: 'progressbar',
    },
    navigation: {
      nextEl: reviewsSliderEl.closest('.reviews').querySelector('.swiper-arrow-next'),
      prevEl: reviewsSliderEl.closest('.reviews').querySelector('.swiper-arrow-prev'),
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 2.4,
      },
    },
  });
}

/* Обрезка длинных отзывов */

function initReviewsTextToggle() {
  const reviewItems = document.querySelectorAll('.reviews__item-text span');
  if (!reviewItems.length) return;

  reviewItems.forEach(function (item) {
    const fullText = item.textContent.trim();

    if (fullText.length <= 280) return;

    const visibleText = fullText.slice(0, 280) + '...';
    const hiddenText = fullText.slice(280);

    const visibleSpan = document.createElement('span');
    visibleSpan.textContent = visibleText;

    const hiddenSpan = document.createElement('span');
    hiddenSpan.textContent = hiddenText;
    hiddenSpan.classList.add('reviews__hidden-text');

    const toggleBtn = document.createElement('button');
    toggleBtn.textContent = 'Читать весь отзыв';
    toggleBtn.classList.add('reviews__showmore');
    toggleBtn.type = 'button';

    item.textContent = '';
    item.appendChild(visibleSpan);
    item.appendChild(hiddenSpan);
    item.parentElement.appendChild(toggleBtn);

    toggleBtn.addEventListener('click', function () {
      const isActive = hiddenSpan.classList.toggle('active');
      toggleBtn.textContent = isActive ? 'Скрыть отзыв' : 'Читать весь отзыв';
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initReviewsSlider();
  initReviewsTextToggle();
});
